import NiceModal from "@ebay/nice-modal-react";
import { lazy } from "react";

const ErrorModal = lazy(() => import("@components/ErrorModal"))
const Toast = lazy(() => import("@components/Toast"))
const OCRModal = lazy(() => import("@components/OCRModal"))
const PdfModal = lazy(() => import("@components/PdfModal"));

NiceModal.register("error-modal", ErrorModal);
NiceModal.register("ocr-modal", OCRModal);
NiceModal.register("pdf-modal", PdfModal);

// Toasts.

NiceModal.register("toast", Toast);
